import React, { createContext, useState, useContext } from "react";

interface ParamsContextType {
  routeParams: Map<string, URLSearchParams>;
  setRouteParams: (route: string, params: URLSearchParams) => void;
}

const ParamsContext = createContext<ParamsContextType | undefined>(undefined);

export const ParamsProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [routeParams, setRouteParamsState] = useState<
    Map<string, URLSearchParams>
  >(new Map());

  const setRouteParams = (route: string, params: URLSearchParams) => {
    setRouteParamsState((prev) => {
      const newMap = new Map(prev);

      if (Array.from(params.entries()).length === 0) {
        newMap.delete(route);
      } else {
        newMap.set(route, params);
      }

      return newMap;
    });
  };

  return (
    <ParamsContext.Provider value={{ routeParams, setRouteParams }}>
      {children}
    </ParamsContext.Provider>
  );
};

export const useParamsContext = () => {
  const context = useContext(ParamsContext);
  if (!context) {
    throw new Error("useParamsContext must be used within a ParamsProvider");
  }
  return context;
};
